import React, {useState} from 'react';
import BookingInfo from './BookingInfo/BookingInfo';
import ContactDetails from './ContactDetails/ContactDetails';
import OfficeAddress from './OfficeAddress/OfficeAddress';
import PageHeader from './PageHeader/PageHeader';

import * as S from './ContactUs.styles';

const ContactUs = () => {
  const [currentLang, setCurrentLang] = useState('english');

  const handleOnLanguageChange = option => {
    if (option.target.id === 'english') {
      document.querySelector('html').setAttribute('dir', 'ltr');
      setCurrentLang(option.target.id);
    } else {
      document.querySelector('html').setAttribute('dir', 'rtl');
      setCurrentLang(option.target.id);
    }
  };

  return (
    <S.PageWrapper>
      <S.PageContent>
        <PageHeader handleChange={handleOnLanguageChange} currentLang={currentLang} />
        <ContactDetails currentLang={currentLang} />
        <OfficeAddress currentLang={currentLang} />
        <BookingInfo
          heading={currentLang === 'arabic' ? 'الحجوزات الجارية' : 'Existing Bookings'}
          description={
            currentLang === 'arabic'
              ? `ريةيرجى الاطلاع على قسم رحلاتي من التطبيق أو الموقع الإلكتروني للحصول على التذكرة الإلكترونية / الإلغاءات / حالة الرحلة
`
              : 'For E-Tickets/Cancellations/Refund Status, please visit the My Trips section on App or Website'
          }
          customClass="appendTop40"
        />
        <BookingInfo
          heading={currentLang === 'arabic' ? 'الحجوزات الجديدة' : 'New Bookings'}
          description={
            currentLang === 'arabic'
              ? `بوسعك إجراء الحجز عبر الإنترنت من خلال موقعنا الإلكتورني وسداد المبلغ باستخدام مجموعة
متنوعة من خيارات الدفع الآمنة المتوفرة.
`
              : 'You can make a booking online through our website and complete your transaction using a variety of secure payment options that are available.'
          }
          customClass="appendTop16"
        />
      </S.PageContent>
    </S.PageWrapper>
  );
};

export default ContactUs;
